import {Component} from '@angular/core';
import {DynamicDialogRef} from 'primeng/dynamicdialog';

@Component({
    selector: 'reset-merchant-client-secret',
    templateUrl: './reset-merchant-client-secret.component.html',
    styleUrls: ['./reset-merchant-client-secret.component.scss'],
    standalone: false
})
export class ResetMerchantClientSecretComponent
{
    email: string = '';

    constructor(protected dialogRef: DynamicDialogRef<ResetMerchantClientSecretComponent>)
    {
    }

    submit(): void
    {
        this.dialogRef.close(this.email.trim());
    }

    cancel(): void
    {
        this.dialogRef.close();
    }
}
